import { LogoutOutlined, UserOutlined } from "@ant-design/icons";
import { Avatar, Space, Tooltip } from "antd";
import { createUseStyles } from "react-jss";
import { useNavigate } from "react-router-dom";
import { capitalizeWord } from "../../common/utils/common";
import { _STYLES } from "../../common/utils/customStyles";
import { useAuth } from "../contexts/AuthContextProvider";
import { useMetaContext } from "../contexts/MetaContextProvider";
import headerMenuStyles from "../headerMenu/headerMenuStyles";
import { ROUTES } from "../navigation";

const { textSm3, w100, textSm2 } = _STYLES;
const { userMenuWrap, userBtn } = headerMenuStyles;
const useStyles = createUseStyles({
  textSm3,
  w100,
  userMenuWrap,
  userBtn,
  textSm2,
  sidebarCard: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    padding: "12px 16px",
    borderTop: "1px solid rgba(255,255,255,0.08)",
    gap: 12,
    overflow: "hidden",
    cursor: "pointer",
    transition: "background 0.18s",
    "&:hover": {
      background: "rgba(255,255,255,0.06)",
    },
  },
  profileArea: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    flex: 1,
    overflow: "hidden",
  },
  logoutBtn: {
    flexShrink: 0,
    color: "rgba(255,255,255,0.45)",
    fontSize: 15,
    cursor: "pointer",
    padding: "6px 8px",
    borderRadius: 6,
    background: "transparent",
    border: "none",
    outline: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "background 0.18s, color 0.18s",
    "&:hover": {
      background: "rgba(239,68,68,0.15)",
      color: "#ef4444",
    },
  },
  sidebarName: {
    margin: 0,
    fontSize: "0.875rem",
    fontWeight: 600,
    color: "rgba(255,255,255,0.9)",
    lineHeight: 1.3,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  sidebarRole: {
    fontSize: "0.75rem",
    color: "rgba(255,255,255,0.5)",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  sidebarTextWrap: {
    overflow: "hidden",
    minWidth: 0,
    flex: 1,
  },
  sidebarBtnCollapsed: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    padding: "12px 0",
    background: "transparent",
    border: "none",
    borderTop: "1px solid rgba(255,255,255,0.08)",
    cursor: "pointer",
    outline: "none",
    "&:hover": {
      background: "rgba(255,255,255,0.06)",
    },
  },
});

const UserMenu = ({ sidebar, collapsed }) => {
  const classes = useStyles();

  const { isResponsive } = useMetaContext();
  const { logout, loggedUser, isCustomer, userType } = useAuth();
  const navigate = useNavigate();

  const fullName = isCustomer
    ? loggedUser?.firstName + " " + loggedUser?.lastName
    : loggedUser?.fullName;

  if (collapsed && sidebar) {
    return (
      <div style={{ borderTop: "1px solid rgba(255,255,255,0.08)", display: "flex", flexDirection: "column", alignItems: "center", gap: 4, padding: "10px 0" }}>
        <Tooltip title="My Profile" placement="right">
          <button className={classes.sidebarBtnCollapsed} style={{ borderTop: "none", padding: "6px 0" }} onClick={() => navigate(ROUTES.settings)}>
            <Avatar src={""} size={30} icon={<UserOutlined />} style={{ background: "#ffffff", color: "#1B2A6B" }} />
          </button>
        </Tooltip>
        <Tooltip title="Logout" placement="right">
          <button className={classes.sidebarBtnCollapsed} style={{ borderTop: "none", padding: "6px 0" }} onClick={logout}>
            <LogoutOutlined style={{ color: "rgba(255,255,255,0.45)", fontSize: 15 }} />
          </button>
        </Tooltip>
      </div>
    );
  }

  if (!sidebar) {
    return (
      <div className={classes.userBtn} style={{ cursor: "pointer" }} onClick={() => navigate(ROUTES.settings)}>
        <Space align="center" size={16}>
          <Avatar src={""} size={isResponsive ? 32 : 40} icon={<UserOutlined />} />
          <Space size={0} direction="vertical">
            <h6 className={classes.textSm3}>{fullName}</h6>
            <span className={classes.textSm2}>{capitalizeWord(userType)}</span>
          </Space>
        </Space>
      </div>
    );
  }

  return (
    <div className={classes.sidebarCard}>
      <Tooltip title="My Profile" placement="top">
        <div className={classes.profileArea} onClick={() => navigate(ROUTES.settings)}>
          <Avatar
            src={""}
            size={30}
            icon={<UserOutlined />}
            style={{ flexShrink: 0, background: "#ffffff", color: "#1B2A6B" }}
          />
          <div className={classes.sidebarTextWrap}>
            <h6 className={classes.sidebarName}>{fullName}</h6>
            <span className={classes.sidebarRole}>{capitalizeWord(userType)}</span>
          </div>
        </div>
      </Tooltip>
      <Tooltip title="Logout" placement="top">
        <button className={classes.logoutBtn} onClick={logout}>
          <LogoutOutlined />
        </button>
      </Tooltip>
    </div>
  );
};

export default UserMenu;
